import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import NOIBox from "./NOIBox";

import { noiEndPoints } from "../../../../services/apiEndPoints";
import { roiIncreaseData } from "../../sample";
import { getData } from "../../../../services/api";

const RoiIncrease = ({ filtervalue, handleChange, value }) => {
  const [roiIncrease, setRoiIncrease] = useState(roiIncreaseData);
  const { period, startDate, endDate } = useSelector(
    (state) => state.selectedPeriods
  );

  useEffect(() => {
    const dateQueryParams = {
      period,
      startDate,
      endDate,
    };
    if (filtervalue) {
      getData(
        noiEndPoints.ROI_INCREASE,
        (data) => {
          setRoiINcreasePowerRevenue(data, filtervalue);
        },
        { existing_roi: filtervalue, ...dateQueryParams }
      );
    }
  }, [period, startDate, endDate, filtervalue]);

  const setRoiINcreasePowerRevenue = (roiIncreasePR, exitingParameter) => {
    setRoiIncrease((prevState) => {
      return {
        ...prevState,
        rows: prevState.rows.map((val) => {
          if (!roiIncreasePR[val.key] && roiIncreasePR[val.key] !== 0)
            return { ...val, value: exitingParameter };
          return {
            ...val,
            value: `${roiIncreasePR[val.key]
              .toFixed(1)
              .toString()
              .replace(/\.0$/, "")}%`,
          };
        }),
        chartData: {
          ...prevState.chartData,
          data: prevState.chartData.data.map(() => {
            return {
              power_rev_ROI_increase: roiIncreasePR.roi_increase,
              existing_ROI: exitingParameter,
            };
          }),
        },
      };
    });
  };

  return (
    <NOIBox
      item={roiIncrease}
      filtervalue={value}
      handleChange={handleChange}
    />
  );
};

export default RoiIncrease;
